import { render, staticRenderFns } from "./CowDetails.vue?vue&type=template&id=5c7d3bfd&scoped=true&"
import script from "./CowDetails.vue?vue&type=script&lang=js&"
export * from "./CowDetails.vue?vue&type=script&lang=js&"
import style0 from "./CowDetails.vue?vue&type=style&index=0&id=5c7d3bfd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c7d3bfd",
  null
  
)

export default component.exports